<template>
    <div class="col-12 digitalstudies-searchbar">
        <form class="" @submit="submitForm($event)">
            <div class="input-group mb-3 form-group">
                <div class="input-group-prepend d-none d-md-inline">
                    <select class="custom-select form-control discipline-select">
                        <option selected>{{$t('digital_studies.all_courses')}}</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                    </select>
                </div>
                <input type="text" class="form-control">
                <div class="input-group-append">
                    <button type="button" class="btn btn-primary btn-search">{{$t('digital_studies.search')}}</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "design-2021-digistudies-search",
        methods: {
            submitForm(event) {
                event.preventDefault();
            }
        }
    }
</script>

<style scoped lang="scss">
    .btn-search {
        padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
    }


    @media (min-width: 992px) {
        .digitalstudies-searchbar {
            margin-bottom: 60px;
        }

        .discipline-select {
            min-width: 125px;
        }
    }

</style>
